export const color_dictionary = {
    metall: {
        "#cbd0cc": "RAL 7035 Светло-серый",
        "#596163": "RAL 7012 Темно-серый",
        "#34343A": "RAL 9005 Черный",
        "#f3f3f3": "RAL 9003 Белый",
    },
    kromka: {
        "#730f11": "Красный",
        "#2159a4": "Синий",
        "#868684": "Серый",
        "#272727": "Черный",
        "#E6CBB3": "Бежевый",
    },
};
